// Hit rates + $2 win-bet ROI for archived Race at a Glance snapshots (scored ones only).
const inTop = (posts, wps, n) => posts.some((p) => wps.slice(0, n).includes(p));

const blank = () => ({ n: 0, win: 0, top2: 0, top3: 0, bet: 0, ret: 0, wpBet: 0, wpRet: 0 });
const tally = (acc, posts, s) => {
  if (!posts.length) return;
  const wps = s.wps;
  acc.n += 1;
  acc.bet += 2 * posts.length;
  acc.wpBet += 4 * posts.length;
  if (inTop(posts, wps, 1)) {
    acc.win += 1;
    acc.ret += Number(s.win_payoff) || 0;
    acc.wpRet += Number(s.win_payoff) || 0;
  }
  for (const p of posts) acc.wpRet += Number((s.place_payoffs || {})[String(p)]) || 0;
  if (inTop(posts, wps, 2)) acc.top2 += 1;
  if (inTop(posts, wps, 3)) acc.top3 += 1;
};

export const IQ_BUCKETS = ["1", "2", "3", "4", "5", "6+", "Unranked"];

export const glanceStats = (snaps) => {
  const out = { scored: 0, strong: blank(), key: blank(), longshot: blank(), iq: {} };
  IQ_BUCKETS.forEach((b) => (out.iq[b] = 0));
  for (const s of snaps) {
    const wps = s.wps || [];
    if (!wps.length) continue;
    out.scored += 1;
    tally(out.strong, s.strong || [], s);
    tally(out.key, s.key != null ? [s.key] : [], s);
    tally(out.longshot, s.longshots || [], s);
    const pos = (s.iq_order || []).indexOf(wps[0]);
    out.iq[pos < 0 ? "Unranked" : pos >= 5 ? "6+" : String(pos + 1)] += 1;
  }
  return out;
};

const isoDaysAgo = (n, today) => {
  const [y, m, d] = today.split("-").map(Number);
  const dt = new Date(y, m - 1, d - n);
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`;
};

// range: "today" | "7d" | "all"; today = local YYYY-MM-DD.
export const filterByRange = (snaps, range, today) => {
  if (range === "today") return snaps.filter((s) => s.date === today);
  if (range === "7d") {
    const from = isoDaysAgo(6, today);
    return snaps.filter((s) => s.date >= from && s.date <= today);
  }
  return snaps;
};

export const pct = (a, n) => (n ? `${Math.round((a / n) * 100)}%` : "—");
export const roi = (s) => (s.bet ? `${Math.round(((s.ret - s.bet) / s.bet) * 100)}%` : "—");
export const wpRoi = (s) => (s.wpBet ? `${Math.round(((s.wpRet - s.wpBet) / s.wpBet) * 100)}%` : "—");
export const money = (n) => `$${(Math.round(n * 100) / 100).toFixed(2)}`;
